import type { IconSvgObject } from './types';

const CodeSimpleIcon: IconSvgObject = [
  ["path", { d: "M8 6L2 12L8 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 6L22 12L16 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CodeSimpleIcon;
